/* ============================================================================
   RADAR DE CLIENTES — quien se esta enfriando
   ---------------------------------------------------------------------------
   Cada cliente tiene su ritmo. El portal lo calcula con SU historial y avisa
   cuando se pasa de lo suyo. No es una lista de "inactivos a 60 dias": para
   un cliente 60 dias es normal y para otro significa que ya compro en otro
   lado.

   Lo que hace util cada fila es el MOTIVO. No dice "cliente inactivo", dice
   "compraba cada 31 dias, lleva 82". Eso es un argumento para llamar.

   Y al lado, el boton para armarle la vitrina con lo que suele comprar y
   mandarsela por WhatsApp. De detectar el problema a la cotizacion en su
   telefono, en dos toques.
============================================================================ */

var RAD_ROWS = [], RAD_CARGADO = false, RAD_FILTRO = '', RAD_ERROR = '';

// Por debajo de vez y media su ritmo es ruido: no se avisa.
var RAD_UMBRAL = 1.5;

function radRol(){ try{ return String((CU&&CU.rol)||'').toLowerCase(); }catch(e){ return ''; } }
function radVeTodo(){
  return ['admin','administrador','gerencia'].indexOf(radRol())>=0;
}
function radPuede(){ return radRol()!=='cliente' && !!radRol(); }

function radEsc(s){
  return String(s==null?'':s).replace(/[&<>"]/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];
  });
}
function radMon(v){
  return '$'+(Number(v)||0).toLocaleString('en-US',
    {minimumFractionDigits:0, maximumFractionDigits:0});
}

async function radCargar(){
  if(RAD_CARGADO) return;
  RAD_CARGADO = true;
  if(!radPuede()) return;
  try{
    var cond = 'select=*&order=venta_12m.desc&limit=300';
    if(!radVeTodo()){
      var sc = null;
      try{ sc = (CU && CU.slpcode); }catch(e){}
      if(sc==null || sc===''){
        RAD_ERROR = 'Tu usuario no tiene c\u00f3digo de vendedor en SAP.';
        return;
      }
      cond += '&slpcode=eq.' + encodeURIComponent(sc);
    }
    RAD_ROWS = (await qAll('radar_clientes', cond) || [])
      .filter(function(r){ return Number(r.atraso)||0 ? true : r.motivo!=='ritmo'; });
  }catch(e){
    RAD_ROWS = [];
    RAD_ERROR = String((e&&e.message)||e);
  }
  radPintarTarjeta();
  radRender();
}

function radFiltradas(){
  if(!RAD_FILTRO) return RAD_ROWS;
  return RAD_ROWS.filter(function(r){ return r.motivo===RAD_FILTRO; });
}

// ── La tarjeta del dashboard ────────────────────────────────────────────────
// Va arriba a proposito: una pantalla que hay que ir a buscar no la abre
// nadie. Esto es lo primero que ve el vendedor por la mañana.
function radPintarTarjeta(){
  var c = document.getElementById('rad-card');
  if(!c) return;
  if(!radPuede() || (!RAD_ROWS.length && !RAD_ERROR)){ c.innerHTML=''; return; }
  if(RAD_ERROR){
    c.innerHTML = '<div class="card" style="font-size:12.5px;color:var(--text3)">'
      + radEsc(RAD_ERROR) + '</div>';
    return;
  }

  var top = RAD_ROWS.slice().sort(function(a,b){
    return (Number(b.venta_12m)||0) - (Number(a.venta_12m)||0);
  }).slice(0,4);
  var juego = RAD_ROWS.reduce(function(s,r){ return s + (Number(r.venta_12m)||0); }, 0);

  var h = '<div class="card">'
    + '<div class="ch" style="flex-wrap:wrap;gap:8px">'
      + '<span class="ct">\u26a0\ufe0f Se est\u00e1n enfriando</span>'
      + '<span style="font-size:12.5px;color:var(--text3)">'
      + RAD_ROWS.length + ' cliente(s) \u00b7 ' + radMon(juego) + ' al a\u00f1o en juego</span>'
      + '<a href="javascript:void(0)" style="margin-left:auto;font-size:12.5px" '
      + 'onclick="go(\'radar\',null)">Ver todos</a>'
    + '</div>'
    + '<div style="overflow-x:auto"><table class="tbl" style="margin:0">';

  top.forEach(function(r){
    h += '<tr>'
      + '<td><b>' + radEsc(r.cardname||r.cardcode) + '</b>'
        + '<div style="font-size:11.5px;color:var(--text3)">' + radEsc(r.detalle||'') + '</div></td>'
      + '<td style="text-align:right;white-space:nowrap">' + radBadge(r) + '</td>'
      + '<td style="text-align:right;font-weight:700;white-space:nowrap">'
        + radMon(r.venta_12m) + '</td>'
      + '<td style="text-align:right;white-space:nowrap">'
        + '<button class="btn btn-sm" onclick="radVitrina(\''
        + String(r.cardcode).replace(/'/g,"\\'") + '\')">Vitrina</button></td>'
      + '</tr>';
  });
  c.innerHTML = h + '</table></div></div>';
}

function radBadge(r){
  var d = Number(r.dias_sin)||0, a = Number(r.atraso)||0;
  if(r.motivo==='categoria')
    return '<span class="badge b-amber">dej\u00f3 un grupo</span>';
  if(r.motivo==='caida')
    return '<span class="badge b-amber">compra menos</span>';
  return '<span class="badge ' + (a>=3 ? 'b-red' : 'b-amber') + '">'
    + d + ' d\u00edas</span>';
}

// ── La pantalla completa ────────────────────────────────────────────────────
function radRender(){
  var c = document.getElementById('rad-lista');
  if(!c) return;
  if(!radPuede()){
    c.innerHTML='<div class="card" style="text-align:center;padding:28px;color:var(--text3)">'
      +'Esta pantalla no est\u00e1 disponible para tu usuario.</div>';
    return;
  }
  if(RAD_ERROR){
    c.innerHTML='<div class="card" style="padding:16px;color:var(--red)">'
      +radEsc(RAD_ERROR)+'</div>';
    return;
  }
  if(!RAD_CARGADO){
    c.innerHTML='<div class="card" style="text-align:center;padding:28px;color:var(--text3)">'
      +'Calculando\u2026</div>';
    return;
  }

  var n = {ritmo:0, categoria:0, caida:0};
  RAD_ROWS.forEach(function(r){ if(n[r.motivo]!=null) n[r.motivo]++; });

  var h = '<div class="card" style="margin-bottom:12px">'
    + '<div style="display:flex;gap:7px;flex-wrap:wrap">'
    + radChip('', 'Todos', RAD_ROWS.length)
    + radChip('ritmo', 'Se pasaron de su ritmo', n.ritmo)
    + radChip('categoria', 'Dejaron un grupo', n.categoria)
    + radChip('caida', 'Compran menos', n.caida)
    + '</div></div>';

  var rows = radFiltradas();
  if(!rows.length){
    c.innerHTML = h + '<div class="card" style="text-align:center;padding:28px;'
      + 'color:var(--text3)">Ninguno por aqu\u00ed. Buena se\u00f1al.</div>';
    return;
  }

  h += '<div style="overflow-x:auto"><table class="tbl">'
    + '<tr><th>Cliente</th>'
    + (radVeTodo() ? '<th>Vendedor</th>' : '')
    + '<th>Qu\u00e9 pasa</th><th style="text-align:right">Ritmo</th>'
    + '<th style="text-align:right">Sin comprar</th>'
    + '<th style="text-align:right">Venta 12m</th><th></th></tr>';

  rows.forEach(function(r){
    var cJs = String(r.cardcode).replace(/'/g,"\\'");
    h += '<tr>'
      + '<td><a href="javascript:void(0)" onclick="verCliente(\'' + cJs + '\')">'
        + radEsc(r.cardname||r.cardcode) + '</a>'
        + '<div style="font-size:11px;color:var(--text3)">' + radEsc(r.cardcode) + '</div></td>'
      + (radVeTodo() ? ('<td style="font-size:12px">' + radEsc(r.nombrevendedor||'') + '</td>') : '')
      + '<td><div style="font-size:12.5px">' + radEsc(r.detalle||'') + '</div>'
        + '<div style="margin-top:3px">' + radBadge(r) + '</div></td>'
      + '<td style="text-align:right;white-space:nowrap">'
        + (r.ritmo_dias ? ('cada ' + r.ritmo_dias + ' d') : '\u2014') + '</td>'
      + '<td style="text-align:right;white-space:nowrap">' + (r.dias_sin||0) + ' d'
        + '<div style="font-size:11px;color:var(--text3)">'
        + (r.ultima_compra ? fmtD(r.ultima_compra) : '') + '</div></td>'
      + '<td style="text-align:right;font-weight:700;white-space:nowrap">'
        + radMon(r.venta_12m) + '</td>'
      + '<td style="text-align:right;white-space:nowrap">'
        + '<button class="btn btn-sm btn-p" onclick="radVitrina(\'' + cJs + '\')">'
        + 'Armar vitrina</button></td>'
      + '</tr>';
  });
  c.innerHTML = h + '</table></div>';
}

function radChip(val, txt, n){
  var act = (RAD_FILTRO===val);
  return '<button class="btn btn-sm' + (act?' btn-p':'') + '" '
    + 'onclick="RAD_FILTRO=\'' + val + '\';radRender()">' + txt
    + ' <span style="opacity:.7">' + n + '</span></button>';
}

// ── Armar la vitrina con lo que suele comprar ───────────────────────────────
// Aqui esta el valor: de ver el problema a tener la cotizacion en su WhatsApp
// sin pasar por elegir productos a mano.
async function radVitrina(cardcode){
  var r = RAD_ROWS.filter(function(x){ return x.cardcode===cardcode; })[0];
  if(!r){ alert('No encuentro ese cliente.'); return; }

  var hab = r.habituales;
  try{ if(typeof hab==='string') hab = JSON.parse(hab); }catch(e){ hab = []; }
  if(!hab || !hab.length){
    alert('Este cliente no tiene compras repetidas suficientes para armarle '
      + 'una vitrina autom\u00e1tica.\n\nArmala a mano desde Nuevo pedido.');
    return;
  }

  // Se cargan en el carrito de Nuevo pedido y de ahi sigue el camino de
  // siempre: el vendedor revisa, ajusta cantidades y manda por WhatsApp.
  npCli = {cardcode: r.cardcode, cardname: r.cardname || r.cardcode};
  npLineas = [];

  var codes = hab.slice(0,14).map(function(x){ return x.itemcode; });
  var precios = {};
  try{
    var inList = codes.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
    var inv = await q('vista_inventario',
      'select=itemcode,itemname,precioventa,unidadesbulto&itemcode=in.('+inList+')'
      +'&limit='+codes.length) || [];
    inv.forEach(function(x){ precios[x.itemcode] = x; });
  }catch(e){}

  hab.slice(0,14).forEach(function(x){
    var p = precios[x.itemcode] || {};
    var b = Math.max(1, Number(p.unidadesbulto)||1);
    npLineas.push({
      itemcode: x.itemcode,
      itemname: p.itemname || x.nombre || x.itemcode,
      // Un bulto de cada: es una propuesta, el vendedor la ajusta.
      quantity: b,
      price: Number(p.precioventa)||0,
      discount: 0,
      bulto: b
    });
  });

  try{ BD_ID = null; BD_ULT = ''; }catch(e){}
  go('nuevo_pedido', document.getElementById('nav-np'));
  setTimeout(function(){
    try{
      var nm=document.getElementById('np-cli-name'); if(nm) nm.textContent=npCli.cardname;
      var mt=document.getElementById('np-cli-meta'); if(mt) mt.textContent=npCli.cardcode;
      var av=document.getElementById('np-cli-av');
      if(av) av.textContent=(npCli.cardname||'?').slice(0,2).toUpperCase();
      var inp=document.getElementById('np-cli-q');   if(inp) inp.style.display='none';
      var sel=document.getElementById('np-cli-sel'); if(sel) sel.style.display='block';
    }catch(e){}
    try{ cotizUpdate(); }catch(e){}
    try{ npRenderLineas(); }catch(e){}
    try{ npUpdateBtn && npUpdateBtn(); }catch(e){}
    try{ npIr(3); }catch(e){}
    try{
      alert('Carg\u00e9 ' + npLineas.length + ' art\u00edculos que ' +
        (r.cardname||'este cliente') + ' suele comprar, un bulto de cada uno.\n\n' +
        'Ajusta las cantidades y pulsa Mandar por WhatsApp.');
    }catch(e){}
  }, 220);
}

function radInit(){
  if(!RAD_CARGADO) radCargar(); else radRender();
}
